import { render, staticRenderFns } from "./_list_deadline.vue?vue&type=template&id=253b3d3a&"
import script from "./_list_deadline.vue?vue&type=script&lang=js&"
export * from "./_list_deadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports